import axios from "axios";
const baseURL: any = process.env.REACT_APP_API_URL;

export const getDepartment = async ({ signal }: AbortController) => {
  try {
    const { data } = await axios.get(`${baseURL}/departamentos`, { signal });
    return data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export function getCity(id: string) {
  return axios.get(`${baseURL}/departamento/${id}/ciudades`);
}

export function getDistrict(id: string) {
  return axios.get(`${baseURL}/ciudad/${id}/barrios`);
}
